import { createAsyncThunk } from '@reduxjs/toolkit';
import { getWhatsAppChat } from 'services/whatsAppMessaging';
import { IWhatsAppChat } from 'services/whatsAppMessaging/types';

export const ThunkGetWhatsAppChat = createAsyncThunk<IWhatsAppChat, string>(
  'whatsAppMessaging/getChat',
  async chatId => {
    const { data } = await getWhatsAppChat(chatId);
    return data;
  },
);
